export const MODULE_NAME = 'xen:macro';
export const EXTENSION_NAMESPACE = 'com.atlassian.ecosystem';
export const P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
export const CONNECT_ADDON_ACTION_SUBJECT = 'connectAddon';
export const MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT = 'migratedServerP2Addon';
export const EXTENSION_TYPE_BODIED = 'bodiedExtension';
export const EXTENSION_TYPE_MULTI_BODIED = 'multiBodiedExtension';
export const FORGE_EXTENSION = 'forge.ui.extension';
export const FORGE_DOC_UPDATED_EVENT = 'forgeDocUpdated';
/**
 * Parameter the Confluence renderer reads to decide whether a block extension is painted inline.
 * Camel-cased because the monolith camel-cases parameters on the `ac:adf-node` storage path that
 * `com.atlassian.ecosystem` nodes take.
 */
export const MACRO_OUTPUT_TYPE_PARAM = 'atlassianMacroOutputType';
/**
 * Marks a node as inserted by an app that declares `outputType: inline`, so the renderer can scope
 * its Forge-specific inline styling to those nodes only.
 *
 * `MACRO_OUTPUT_TYPE_PARAM` cannot serve that purpose: migrated Connect content carries the same
 * marker, and after a Connect-to-Forge upgrade plus one storage round trip its `guestParams` key is
 * camel-cased into exactly the same shape. A key that only this code writes is the only signal at
 * render time that distinguishes the two populations, since the renderer sees the stored node and
 * never the manifest.
 *
 * No hyphens, deliberately: the monolith applies `hyphenToCamel` to parameters on the `ac:adf-node`
 * path that `com.atlassian.ecosystem` nodes take, so a hyphenated name would not survive intact.
 */
export const FORGE_INLINE_BODIED_PARAM = 'atlassianForgeInlineBodied';
